export const messages = {
  'any.required': 'Campo obrigatório',
  'string.empty': 'Campo obrigatório',
  'string.trim': 'Campo obrigatório',
  'string.base': 'Campo obrigatório',
  'string.email': 'Informe um email válido'
}
